var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReferralPoints(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 33,
    viewBox: "0 0 47 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.443359 26.1607V28.8172C0.443359 31.0133 8.13065 32.7989 17.6057 32.7989C27.0807 32.7989 34.768 31.0133 34.768 28.8172V26.1607C31.0763 27.9711 24.3276 28.8172 17.6057 28.8172C10.8838 28.8172 4.13505 27.9711 0.443359 26.1607ZM29.0472 8.90871C38.5223 8.90871 46.2096 7.12316 46.2096 4.92701C46.2096 2.73085 38.5223 0.945312 29.0472 0.945312C19.5722 0.945312 11.8849 2.73085 11.8849 4.92701C11.8849 7.12316 19.5722 8.90871 29.0472 8.90871ZM0.443359 19.6344V22.8446C0.443359 25.0408 8.13065 26.8263 17.6057 26.8263C27.0807 26.8263 34.768 25.0408 34.768 22.8446V19.6344C31.0763 21.7497 24.3187 22.8446 17.6057 22.8446C10.8927 22.8446 4.13505 21.7497 0.443359 19.6344ZM37.6284 20.3188C42.7503 19.6282 46.2096 18.3466 46.2096 16.8721V14.2156C44.1358 15.2359 41.0877 15.9327 37.6284 16.3619V20.3188ZM17.6057 10.8996C8.13065 10.8996 0.443359 13.1268 0.443359 15.8767C0.443359 18.6265 8.13065 20.8538 17.6057 20.8538C27.0807 20.8538 34.768 18.6265 34.768 15.8767C34.768 13.1268 27.0807 10.8996 17.6057 10.8996ZM37.2083 14.4022C42.5715 13.7303 46.2096 12.4114 46.2096 10.8996V8.24302C43.0363 9.80459 37.5837 10.6445 31.845 10.8436C34.482 11.7332 36.4217 12.9277 37.2083 14.4022Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReferralPoints);
export default __webpack_public_path__ + "static/media/referral-points.118c6d78018cdc880ffbc17c7efb1872.svg";
export { ForwardRef as ReactComponent };